import { useMemo } from 'react'

import { TextButton } from 'components'
import { useAppSelector } from 'store'
import useScopeModal from 'hooks/use-scope-modal'
import useLeadDetail from 'hooks/use-lead-detail'

import DuplicatesModal, { DUPLICATE_LIST_MODAL_ID } from 'modules/Leads/shared/Modal/DuplicateList'
import { MODAL_STACK_CONTACT_LIST } from 'modules/Leads/LeadDetail/LeftSection/ContactList'

const ViewDuplicateListButton = () => {
  const leadDuplicate = useAppSelector((state) => state.lead.leadDuplicate)
  const { setModal, setCloseModal } = useScopeModal({
    stack: MODAL_STACK_CONTACT_LIST,
  })
  const { data, canUserEditLeadInfo } = useLeadDetail()

  const duplicateList = useMemo(() => {
    if (!leadDuplicate) {
      return []
    }

    return [...(leadDuplicate?.exacts ?? []), ...(leadDuplicate?.potentials ?? [])]
  }, [leadDuplicate])

  return (
    <TextButton
      size="small"
      onClick={() =>
        setModal(
          <DuplicatesModal
            data={duplicateList}
            leadDetail={data}
            onClose={() => {
              setCloseModal(DUPLICATE_LIST_MODAL_ID)
            }}
            hideMergeButton={!canUserEditLeadInfo || window.location.pathname.includes('newlead')}
          />,
          { id: DUPLICATE_LIST_MODAL_ID },
        )
      }
    >
      View list
    </TextButton>
  )
}

export default ViewDuplicateListButton
